module.exports = __webpack_public_path__ + "img/agree.35d2bd06.png";